import { getBrand } from "@/api";
import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { applyColorScheme, DEFAULT_NEUTRAL_COLOR_SCHEME } from "@/themes";

// get initial whitelabel info from db
export async function getBrandInfo(brandOverride = "") {
  const globalStore = useGlobalConfigsStore();

  // if the current brand value is empty,
  // check if we have a `wl` searchParam in the URL. If so use that as brand. If not keep it empty.
  const brand = (brandOverride || globalStore.brand) ?? "";

  try {
    const brandData = await getBrand("", { brand });
    if (typeof brandData === "string") {
      throw new TypeError("Get-Brand response was a string: " + brandData);
    }

    globalStore.allowedMenuItems = brandData.allowedMenuItems;
    globalStore.company = {
      legalName: brandData.company.legalName,
      mailSender: brandData.company.mailSender,
      websiteTranslatable: brandData.company.websiteTranslatable,
      imprintTranslatable: brandData.company.imprintTranslatable,
      dataPrivacyTranslatable: brandData.company.dataPrivacyTranslatable,
    };

    // set brand and whitelabel information
    globalStore.brand = brandData.brand;
    globalStore._theme = brandData.colorScheme;

    applyColorScheme(globalStore._theme);

    return brandData;
  } catch (error) {
    console.warn(error);
    applyColorScheme(DEFAULT_NEUTRAL_COLOR_SCHEME);
  }
}
